// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SMSUserEntityMapper from "../entity-mapper/SMSUserEntityMapper.bs.js";
import * as SmsMessageEntityMapper from "../entity-mapper/SmsMessageEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as SmsSendMessageEntityMapper from "../entity-mapper/SmsSendMessageEntityMapper.bs.js";
import * as EditSmsTemplateEntityMapper from "../entity-mapper/EditSmsTemplateEntityMapper.bs.js";
import * as SmsTemplateListEntityMapper from "../entity-mapper/SmsTemplateListEntityMapper.bs.js";

var execute = SMSUserEntityMapper.execute;

var CustomerAndPartnerDetailsResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var SMSUserResponseConverter = partial_arg(CustomerAndPartnerDetailsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = SmsMessageEntityMapper.execute;

var PreviouslySentMessagesDetailsResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var SmsMessageResponseConverter = partial_arg$1(PreviouslySentMessagesDetailsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = SmsTemplateListEntityMapper.execute;

var SMSTemplateListResponseConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var SMSTemplateListResponseConverter = partial_arg$2(SMSTemplateListResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = SmsSendMessageEntityMapper.execute;

var SendSMSResponseConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var SmsSendMessageResponseConverter = partial_arg$3(SendSMSResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$4 = EditSmsTemplateEntityMapper.execute;

var EditSmsTemplateResponseConverterConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var EditSmsTemplateResponseConverter = partial_arg$4(EditSmsTemplateResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  CustomerAndPartnerDetailsResponseConverterConfig ,
  SMSUserResponseConverter ,
  PreviouslySentMessagesDetailsResponseConverterConfig ,
  SmsMessageResponseConverter ,
  SMSTemplateListResponseConverterConfig ,
  SMSTemplateListResponseConverter ,
  SendSMSResponseConverterConfig ,
  SmsSendMessageResponseConverter ,
  EditSmsTemplateResponseConverterConfig ,
  EditSmsTemplateResponseConverter ,
  
}
/* SMSUserResponseConverter Not a pure module */
